<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="Student"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="First Name"
        fieldId="firstName"
        v-model="formData.firstName"
        required
      />
      <AddEditFormGroup
        label="Last Name"
        fieldId="lastName"
        v-model="formData.lastName"
        required
      />
      <AddEditFormGroup
        label="Email"
        fieldId="email"
        v-model="formData.email"
        type="email"
        required
      />
      <AddEditFormGroup
        label="Phone"
        fieldId="phone"
        v-model="formData.phone"
        type="tel"
      />
      <AddEditFormGroup
        label="Start Date"
        fieldId="startDate"
        v-model="formData.startDate"
        type="date"
      />
      <AddEditFormGroup
        label="PPL Hours"
        fieldId="pplHours"
        v-model="formData.pplHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="PPL Allotted"
        fieldId="pplAllotted"
        v-model="formData.pplAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="IR Hours"
        fieldId="irHours"
        v-model="formData.irHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="IR Allotted"
        fieldId="irAllotted"
        v-model="formData.irAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CREW Hours"
        fieldId="crewHours"
        v-model="formData.crewHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CREW Allotted"
        fieldId="crewAllotted"
        v-model="formData.crewAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="COM Hours"
        fieldId="comHours"
        v-model="formData.comHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="COM Allotted"
        fieldId="comAllotted"
        v-model="formData.comAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFI Hours"
        fieldId="cfiHours"
        v-model="formData.cfiHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFI Allotted"
        fieldId="cfiAllotted"
        v-model="formData.cfiAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFII Hours"
        fieldId="cfiiHours"
        v-model="formData.cfiiHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="CFII Allotted"
        fieldId="cfiiAllotted"
        v-model="formData.cfiiAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="MULTI Hours"
        fieldId="multiHours"
        v-model="formData.multiHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="MULTI Allotted"
        fieldId="multiAllotted"
        v-model="formData.multiAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="MEI Hours"
        fieldId="meiHours"
        v-model="formData.meiHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="MEI Allotted"
        fieldId="meiAllotted"
        v-model="formData.meiAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="SIM Hours"
        fieldId="simHours"
        v-model="formData.simHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="SIM Allotted"
        fieldId="simAllotted"
        v-model="formData.simAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Ground Hours"
        fieldId="groundHours"
        v-model="formData.groundHours"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Ground Allotted"
        fieldId="groundAllotted"
        v-model="formData.groundAllotted"
        type="number"
        step="any"
      />
      <AddEditFormGroup
        label="Balance"
        fieldId="balance"
        v-model="formData.balance"
        type="number"
        step="any"
      />
      <FileUpload
        label="Student Image"
        fieldId="image"
        v-model="formData.image"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import ActiveStudentsAPIService from "src/servicehandlers/ActiveStudentsAPIService.js";
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";
import FileUpload from "../../../../components/HiloComponents/FileUpload.vue";
const activeStudentsAPIService = new ActiveStudentsAPIService();

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  components: { FileUpload, AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        startDate: "",
        notes: "",
        pplHours: "",
        pplAllotted: "",
        irHours: "",
        irAllotted: "",
        crewHours: "",
        crewAllotted: "",
        comHours: "",
        comAllotted: "",
        cfiHours: "",
        cfiAllotted: "",
        cfiiHours: "",
        cfiiAllotted: "",
        multiHours: "",
        multiAllotted: "",
        simHours: "",
        simAllotted: "",
        groundHours: "",
        groundAllotted: "",
        balance: "",
        image: "",
      },
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getStudent(this.$route.params.id);
    }
    this.loading = false;
  },
  methods: {
    async getStudent(id) {
      try {
        const response = await activeStudentsAPIService.getStudentById(id);
        this.formData = {
          ...response,
          lastName: response.user.lastName,
          firstName: response.user.firstName,
          email: response.user.email,
          phone: response.user.phone,
          image: response.user.image,
          startDate: response.startDate
            ? dayjs(response.startDate).utc().format("YYYY-MM-DD")
            : "",
        };
      } catch (error) {}
    },
    async submitForm(formData) {
      try {
        if (this.isEditMode) {
          await activeStudentsAPIService.update(
            this.$route.params.id,
            formData,
          );
        } else {
          await activeStudentsAPIService.create(formData);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
